var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"r-cblock",style:(_vm.getStyle())},[_c('div',{staticClass:"r-cblock__bg",style:(_vm.getBgColor())}),_c('span',{staticClass:"r-cblock__content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }